import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface PriceShowCsvConfirmModalProps {
  show: boolean;
  onCancel: () => void;
  onOk: () => void;
}

/**
 * CSV出力の実行確認モーダル（D4 step6: PriceShowList から分離）。文言・挙動は分離前と不変。
 */
export const PriceShowCsvConfirmModal: React.FC<PriceShowCsvConfirmModalProps> = ({
  show,
  onCancel,
  onOk,
}) => (
  <Modal show={show} onHide={onCancel}>
    <Modal.Header closeButton className="border-bottom-0">
      <Modal.Title>CSV出力</Modal.Title>
    </Modal.Header>
    <Modal.Body>価格表から価格のあるデータをCSV形式で出力します。よろしいですか？</Modal.Body>
    <Modal.Footer className="border-top-0">
      <Button variant="secondary" className="rounded-pill fs-6 px-4" onClick={onCancel}>
        キャンセル
      </Button>
      <Button variant="success" className="rounded-pill fs-6 px-4" onClick={onOk}>
        OK
      </Button>
    </Modal.Footer>
  </Modal>
);
